import { onReady as onFeaturesReady, track } from "../utils/features";

const OPEN_REVIEWS_TRACKING_KEY = "PDP Click - Open Reviews";

export function fireOpenReviewsOptimizelyEvent(): void {
  onFeaturesReady()
    .then(() => {
      track(OPEN_REVIEWS_TRACKING_KEY);
    })
    .catch(() => {
      // no-op
    });
}
